import { MatIconModule } from "@angular/material/icon";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatChipsModule } from "@angular/material/chips";
import { CaiFrameworkModule } from "@cai-framework";
import { CommonComponentsModule } from "../components.module";
import { CommonPipesModule } from "../../pipes/pipes.module";
import { CommonDirectivesModule } from "../../directives/directives.module";
import { CoreModule } from "../../core/core.module";
import { CustomPipesModule } from "../../core/_pipes/pipe.module";
import { IataCassRegistrationComponent } from "./iata-cass-registration/iata-cass-registration.component";
import { CompleteRegistrationComponent } from "./complete-registration/complete-registration.component";
import { CongratulationComponent } from "./congratulation/congratulation.component";

import { UserRegistrationComponent } from "./user-registration/user-registration.component";
import { RegisterComponent } from "./register.component";
import { InformationRegistrationComponent } from "./information-registration/information-registration.component";
import { ManualCompleteComponent } from "./manual-complete/manual-complete.component";
import { InvalidTokenRegistrationComponent } from "./invalid-token-registration/invalid-token-registration.component";
import { RegistrationVideoComponent } from "./registration-video/registration-video.component";
import { RegistrationProgressBarComponent } from "./registration-progress-bar/registration-progress-bar.component";
import { RegistrationTutorialComponent } from "./registration-tutorial/registration-tutorial.component";
import { AcceptInvitationComponent } from "./accept-invitation/accept-invitation.component";
import {
  RegistrationPasswordFieldComponent
} from "./registration-password-field/registration-password-field.component";

const routes: Routes = [
  {
    "path": "",
    "component": RegisterComponent,
    "children": [
      {
        "path": "",
        "component": UserRegistrationComponent,
        "data": {
          "description":
            "Sign up in 2 minutes for free with CargoMART and manage your shipment from search to tracking with one account, we have everything covered. Register and go.",
        },
      },
      {
        "path": "forwarder/info",
        "component": InformationRegistrationComponent,
      },
      {
        "path": "forwarder/iata-cass",
        "component": IataCassRegistrationComponent,
      },
      {
        "path": "forwarder",
        "component": CompleteRegistrationComponent,
      },
      {
        "path": "invalid",
        "component": InvalidTokenRegistrationComponent,
      },
      {
        "path": "airline",
        "component": CompleteRegistrationComponent,
      },
      {
        "path": "standard",
        "component": CompleteRegistrationComponent,
      },
    ],
  },
];

@NgModule({
  "declarations": [
    RegisterComponent,
    ManualCompleteComponent,
    UserRegistrationComponent,
    IataCassRegistrationComponent,
    CompleteRegistrationComponent,
    CongratulationComponent,
    InformationRegistrationComponent,
    InvalidTokenRegistrationComponent,
    RegistrationVideoComponent,
    RegistrationProgressBarComponent,
    RegistrationTutorialComponent,
    AcceptInvitationComponent,
    RegistrationPasswordFieldComponent,
  ],
  "imports": [
    RouterModule.forChild(routes),
    CommonModule,
    CustomPipesModule,
    CoreModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatIconModule,
    MatChipsModule,
    CommonComponentsModule,
    CommonPipesModule,
    CommonDirectivesModule,
    CaiFrameworkModule,
  ],
})
export class RegisterModule {}
